import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IMasterSuite } from 'src/app/models/mastersuites/mastersuite';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import {
  TransferProductSettingsWizardComponent,
  TransferProductSettingsWizardData,
} from 'src/app/components/home/products/transfer-product-settings-wizard/transfer-product-settings-wizard.component';

@Component({
  selector: 'app-transfer-mastersuite-action',
  templateUrl: './transfer-mastersuite-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class TransferMastersuiteActionComponent implements OnInit {
  @Input() products: IProduct[] = [];
  @Input() masterSuites: IMasterSuite[] = [];
  @Output() actionComplete = new EventEmitter<void>();
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ProductsFull);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onTransfer(): void {
    const data: TransferProductSettingsWizardData = {
      products: this.products,
      masterSuites: this.masterSuites,
    };
    const dialogRef = this.dialog.open(TransferProductSettingsWizardComponent, {
      disableClose: true,
      width: '90vw',
      maxWidth: '1400px',
      maxHeight: '90vh',
      data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.actionComplete.emit();
      }
    });
  }
}
